import { z } from 'zod';

export const GetMaterialQuoteByProductUrlSchema = z.strictObject({
    productId: z.string().uuid(),
});
